module.exports = __webpack_public_path__ + "static/media/felbrycollege-logo.a34bf832.jpg";